// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search_container__oCbId {
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
}

.Search_info__l5702 {
  display: flex;
  align-items: flex-end;
}
.Search_info__l5702 .Search_query__Mw9Ff {
  font-size: 20px;
  font-weight: bold;
  margin-right: 5px;
}
.Search_info__l5702 .Search_results-number__haohi {
  font-size: 12px;
  color: #808080;
  position: relative;
  top: -2px;
}

.Search_pointer__UyyC3 {
  cursor: pointer;
}

@media (min-width: 1300px) {
  .Search_container__oCbId {
    min-height: 550px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Search/Search.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,uBAAA;EAAA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,qBAAA;AADJ;AAEI;EACI,eCPG;EDQH,iBCLD;EDMC,iBAAA;AAAR;AAEI;EACI,eChBC;EDiBD,cEHc;EFId,kBAAA;EACA,SAAA;AAAR;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI;IACI,iBAAA;EADN;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.container {\n    margin: auto;\n    width: fit-content;\n}\n\n.info {\n    display: flex;\n    align-items: flex-end;\n    .query {\n        font-size: typography.$header-s;\n        font-weight: typography.$bold;\n        margin-right: 5px;\n    }\n    .results-number {\n        font-size: typography.$body-s;\n        color: colors.$color-text-disabled;\n        position: relative;\n        top: -2px;\n    }\n}\n\n.pointer{\n    cursor: pointer;\n}\n\n@media (min-width: 1300px) {\n    .container{\n        min-height: 550px;\n    }\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Search_container__oCbId`,
	"info": `Search_info__l5702`,
	"query": `Search_query__Mw9Ff`,
	"results-number": `Search_results-number__haohi`,
	"pointer": `Search_pointer__UyyC3`
};
export default ___CSS_LOADER_EXPORT___;
